// extracted by mini-css-extract-plugin
module.exports = {"pageLoadingIndicatorContainer":"PageLoadingIndicator_pageLoadingIndicatorContainer__2cACY","imageMessage":"PageLoadingIndicator_imageMessage__1ij9l"};